var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.loading,"search":_vm.search,"items-per-page":20},scopedSlots:_vm._u([{key:"item.forgeID",fn:function(ref){
var item = ref.item;
return [_c('ProjectNavigation',{attrs:{"instance":item}})]}},{key:"item.user.display_name",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.user.display_name)+" ")]}},{key:"item.tag.name",fn:function(ref){
var item = ref.item;
return [_c('ProjectTagChip',{attrs:{"tag":item.tag,"id":item.id,"tags":_vm.tags,"loading":_vm.loading}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }